import { DialogData } from "../upload/dialog/dialog.component";
import { TypeDocument } from "./typeDocument";

export class DialogDataImpl implements DialogData {
  constructor(
    public patientKey: number,
    public typeDocument: TypeDocument
  ) { }   
}
